import Component from "vue-class-component";
import Ribbon from "@/core/ribbon/ribbon.vue";
import JhiFooter from "@/core/jhi-footer/jhi-footer.vue";
import JhiNavbar from "@/presentation/containers/header/header.container.vue";
import JhiNavbars from "@/core/jhi-navbar/jhi-navbar.vue";
import BaseComponent from "@/presentation/BaseComponent";
import Login from "@/core/login/login.vue";
import LayoutApp from "@/presentation/layout/layoutApp.vue";
@Component({
  components: {
    ribbon: Ribbon,
    "jhi-navbar": JhiNavbar,
    "jhi-navbars": JhiNavbars,
    "jhi-footer": JhiFooter,
    login: Login,
    "layout-app": LayoutApp,
  },
})
export default class App extends BaseComponent {
  public create() {
    console.log(this.$store.state.auth);
  }

  public currentUser() {
    console.log(this.$store.state.auth);
    return this.$store.state.auth.status.loggedIn;
  }
  public showNavbar() {
    // return true;
    let roles: any = this.currentUser();
    if (roles) {
      return true;
    } else return false;
  }
}
